import React from 'react';

import '../App.css';

const Off = props => {
    return (
        <div className="off_css" style={{visibility: props.off>0 ? 'visible' : 'hidden'}}>
            {props.off}%
        </div>
    )
}

export default Off;